/**
 * @generated SignedSource<<a053ab75415c8ee111b3057d7ca3ab46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastAdminButton_Store$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminPopoverSectionStore_Store">;
  readonly " $fragmentType": "StorecastAdminButton_Store";
};
export type StorecastAdminButton_Store$key = {
  readonly " $data"?: StorecastAdminButton_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminButton_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastAdminButton_Store",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastAdminPopoverSectionStore_Store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "394d5e72c854613f9816c8f0373027b1";

export default node;
